import script from "./VStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./VStatus.vue?vue&type=script&setup=true&lang=ts"

import "./VStatus.vue?vue&type=style&index=0&id=90a96dfc&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90a96dfc"]])

export default __exports__